import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
} from '@mui/material';
import { JSX } from 'react';

interface BooleanSelectProps extends Omit<SelectProps, 'onChange'> {
  /**
   * Callback that is called when the value of the select changes.
   */
  onChange: (value: boolean) => void;
}

/**
 * A select component for boolean values.
 */
const BooleanSelect = ({
  label,
  error,
  value,
  onChange,
  ...props
}: BooleanSelectProps): JSX.Element => {
  const handleChange = (event: SelectChangeEvent<unknown>): void => {
    onChange(event.target.value === 'Yes');
  };

  return (
    <FormControl fullWidth error={error}>
      <InputLabel shrink>{label}</InputLabel>
      <Select {...props} value={value ? 'Yes' : 'No'} label={label} onChange={handleChange}>
        <MenuItem value="Yes">Yes</MenuItem>
        <MenuItem value="No">No</MenuItem>
      </Select>
    </FormControl>
  );
};

export default BooleanSelect;
